import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { Spin } from "antd";
import { Card } from "react-bootstrap";
import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import ErrorPage404 from "../homePage/errorPage404";

const WebPages = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [pageId, setPageId] = useState(null);

  useEffect(() => {
    //loadPage();
    if (pageId != props.match.params.pageId)
      setPageId(props.match.params.pageId);
    //$("html, body").animate({ scrollTop: 0 }, "slow");
  }, [props.match.params]);

  useEffect(() => {
    if (pageId) loadPage();
  }, [pageId]);

  const loadPage = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.ADMISSION.CUSTOM_PAGE + "?slug=" + props.match.params.pageId
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        } else {
          setDataList([]);
        }
        setLoader(false);
      });
  };

  return (
    <>
      <div className="container py-4">
        <Spin spinning={loader}>
          <div style={{ minHeight: "250px" }}>
            {dataList && dataList.id && (
              <Card>
                <Card.Body>
                  <h3
                    className="title_with_halfLine my-3 "
                    style={{ textTransform: "capitalize" }}
                  >
                    {dataList.title}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: dataList.content_html,
                    }}
                  />
                </Card.Body>
              </Card>
            )}
            {!loader && !dataList.id && <ErrorPage404 />}
          </div>
        </Spin>
      </div>
    </>
  );
};

export default withRouter(WebPages);
